import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(3),
      width: '100%',
      height: theme.spacing(16),
    },
  },
  text: {
    padding: theme.spacing(5),
    textAlign: 'center'
  },
  margins: {
    marginRight: 15,
    marginLeft: 15,
    marginBottom: 15
  },
}));
export {useStyles}

